import axios, { AxiosRequestTransformer } from 'axios';
import config from '@/utils/config';

const instance = axios.create({
  baseURL: config.get('payServiceApi'),
});

export type TBookingData = {
  first_name: string;
  last_name: string;
  patronymic: string;
  phone: string;
  email: string;
  region: string;
  vin: string;
  sku: string;
  amount: number;
  confirm_personal_data_processing_policy: boolean;
  confirm_loyalty_program?: boolean;
};

export type TBookingResponse = {
  error_info?: string;
  form_url: string | null;
  order_id: string | null;
};

export function sendBooking(data: TBookingData) {
  return instance.post<TBookingResponse>(`/forms/booking`, { ...data });
}

export type TBookingRequestData = {
  first_name: string;
  last_name: string;
  patronymic: string;
  phone: string;
  email: string;
  region: string;
  vehicle_id: string;
  captcha_token?: string;
  confirm_personal_data_processing_policy: boolean;
  confirm_loyalty_program?: boolean;
};

export type TBookingRequestResponse = {
  error_info?: string;
  booking_request_id: string;
  booking_request_pdf_url: string;
  booking_request_html_url: string;
};

export function sendBookingRequest({ captcha_token, ...data }: TBookingRequestData) {
  const url = config.get('isMobileApp')
    ? '/mobile/forms/booking-request'
    : `/forms/booking-request?x_captcha_token=${captcha_token}`;

  return instance.post<TBookingRequestResponse>(url, { ...data });
}

export type TRegisterPaymentData = {
  booking_request_id: string;
  confirm_contract_conditions: boolean;
};

export type TRegisterPaymentResponse = {
  error_info?: string;
  order_id: string;
  form_url: string;
};

export function sendRegisterPayment(data: TRegisterPaymentData) {
  return instance.post<TRegisterPaymentResponse>(`/forms/register-payment`, { ...data });
}

export type TBookingInfoResponse = {
  client_firstname: string;
  client_lastname: string;
  client_patronymic: string;
  client_email: string;
  client_phone: string;
  client_region: string;
  contract_pdf_url: string;
  contract_html_url: string;
  dealership: string;
  dealership_address: string;
  vehicle_brand: string;
  vehicle_model: string;
  vehicle_version: string;
  vehicle_exterior: string;
  prepayment_amount: number;
  booking_request_id: string;
};

export function getBookingInfo(token: string) {
  return instance.get<TBookingInfoResponse>(`/forms/booking-info/${token}`);
}

export default instance;
